module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921004151_T.f246d9c3.jpg";